import { FC, useEffect, useState } from "react";
import { fetchAsync, postAsync } from "../../services/ApiHandler";
import { Account } from "../../model/Account";
import { removeToken } from "../../services/CookieHandler";
import { Switch } from "@mantine/core";
import toast, { Toaster } from "react-hot-toast";
import { Helmet } from "react-helmet";
import { useHeaderStore } from "../../parts/CommonHeader";
import { getProfileImageUrl } from "../../services/ProfileImageUtil";

export const ProfilePage: FC = () => {
  const [adChecked, setAdChecked] = useState(true);
  const [noticeChecked, setNoticeChecked] = useState(true);
  const { profileImage, setProfileImage, account, fetchAccount } = useHeaderStore();

  useEffect(() => {
  }, [])

  function logout() {
    removeToken();
    window.location.href = '/image-generation'
  }

  async function switchAdChecked(checked: boolean) {
    setAdChecked(checked);
    var param = { isActive: checked ? 1 : 0 };
    const response = await postAsync<string>("Account/SwitchAdFlag", param);
    if(response.code !== 1) {
      toast.error(response.message ?? "");
    }
    fetchAccount();
  }

  async function switchNoticeChecked(checked: boolean) {
    setNoticeChecked(checked);
    var param = { isActive: checked ? 1 : 0 };
    await postAsync<string>("Account/SwitchMailFlag", param);
    fetchAccount();
  }

  return <>
    <Helmet>
      <title>マイページ - Drop AI</title>
      <meta name="description" content="マイページでお客さまのアカウント情報を確認いただけます。" />
      <meta property="og:url" content="https://drop4i.com/account" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="マイページ - Drop AI | 無料で使えるAI画像生成ツール" />
      <meta property="og:description" content="マイページでお客さまのアカウント情報を確認いただけます。" />
    </Helmet>
    <Toaster />
      <div className="min-h-[calc(100vh-76px)] sm:bg-[#eaeaea80]">
        <div className="pt-1"></div>
        <div className="mt-2 sm:mt-10 mx-auto max-w-[800px] bg-white rounded-lg py-4 px-6"> 
          <div className="text-2xl font-bold mb-4">アカウント</div>
          <div className="flex mb-4">
              <img src={getProfileImageUrl(profileImage)} className="h-[100px] w-[100px] rounded-full" />
          </div>
          <div className="mb-4 items-center block sm:flex">
            <span className="flex items-center w-[180px]">
              <img src="/images/icon/icon-user.svg" className="w-[20px] h-[20px] mr-2" />
              <span className="">User ID</span>
            </span>
            <span className="text-sm">{account?.accountId}</span>
          </div>
          <div className="mb-4 items-center block sm:flex">
            <span className="flex items-center w-[180px]">
              <img src="/images/icon/icon-email.svg" className="w-[20px] h-[20px] mr-2" />
              <span className="">メールアドレス</span>
            </span>
            <span className="text-sm">{account?.email}</span>
          </div>
          <div className="flex mb-4 items-center">
            <img src="/images/icon/icon-ad.svg" className="w-[20px] h-[20px] mr-2" />
            <span className="w-[150px]">広告表示</span>
            <Switch
              color="#0909FF"
              checked={false}
              //onChange={(event) => switchAdChecked(event.currentTarget.checked)}
            />
          </div>
          <div className="flex mb-4 items-center">
            <img src="/images/icon/icon-bell.svg" className="w-[20px] h-[20px] mr-2" />
            <span className="w-[150px]">お知らせメール</span>
            <Switch
              color="#0909FF"
              checked={noticeChecked}
              onChange={(event) => switchNoticeChecked(event.currentTarget.checked)}
            />
          </div>
        </div>
      </div>
  </>;
}
  